<template>
    <div class="article-previews">
        <ArticlePreview
            v-for="(article, key) in data.articles"
            :key="key"
            :data="article"
            :has-eager-image="hasEagerImage && key < (isMobileAgent ? 1 : 3)"
            :sizes="getArticleImageSizes(key)"
        />
    </div>
</template>

<script setup lang="ts">
import type { ComponentArticlePreviewsFragment } from '@/graphql/api'

import ArticlePreview from '@/components/cms/component/article-previews/ArticlePreview.vue'
import { useIsMobileAgent } from '@/plugins/is-mobile-agent.ts'
import type { ImageSizes } from '@/components/getImageProps.ts'

defineProps<{
    data: ComponentArticlePreviewsFragment
    hasEagerImage?: boolean
}>()

const isMobileAgent = useIsMobileAgent()

const getArticleImageSizes = (index: number): ImageSizes =>
    index === 2
        ? [
              '100vw',
              [640, 'calc(100vw - 10px)'],
              [1024, 'calc((100vw - 30px) / 2)'],
          ]
        : [
              '100vw',
              [640, 'calc((100vw - 10px) / 2)'],
              [1024, 'calc((100vw - 30px) / 4)'],
          ]
</script>

<style lang="scss" scoped>
.article-previews {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
    gap: 10px;

    @include min-width(640) {
        grid-template-columns: 1fr 1fr;
    }

    @include min-width(1024) {
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    :deep(.article-preview) {
        &:nth-child(3) {
            @include min-width(640) {
                grid-column: 1 / span 2;
                grid-row: 2 / span 2;
            }

            @include min-width(1024) {
                grid-column: 3 / span 2;
                grid-row: 1 / span 2;
            }

            .content {
                @include min-width(1024) {
                    padding: 20px 40px;
                }
            }
        }
    }
}
</style>
